var path = '/templates/projects.segments/campaign_segment_edit_all.html';
var html = "<section class=form-horizontal></section>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./src/zenclerk_modules/projects.segments/campaign_segment_edit_all.html
// module id = 1430
// module chunks = 0